import StorageManager from "@/services/storageManager";

const tier_costs = [];
let cost = null;
for (let id = 1; id <= 5; id++) {
    cost = cost === null ? 20 : cost * 2;
    tier_costs.push({id, cost});
}

const ability_costs = [];
for (let id = 1; id <= 10; id++) {
    cost = Math.ceil(1.03 ** (id * 20));
    ability_costs.push({
        id,
        cost,
    });
}

const vip_levels = [];
let i = 0;
for (let level = 1; level <= 10; level++) {
    vip_levels.push({
        level,
        required: i,
    });
    i = Math.round((i + ((100 * level) ** 1.18)) / 100) * 100;
}

const volume = StorageManager.has('volume')
    ? JSON.parse(StorageManager.get('volume'))
    : {
        music: 100,
        effects: 100,
        announcer: 100,
        voice: 100,
    };
StorageManager.set('volume', JSON.stringify(volume));

let haptic = StorageManager.has('haptic') ? StorageManager.get('haptic') : true;
haptic = haptic === 'true' || haptic === true;
StorageManager.set('haptic', haptic);

const isMasquerade = StorageManager.has('isMasquerade')
    ? StorageManager.get('isMasquerade') === 'true'
    : false;

const replayMode = StorageManager.has('replayMode')
    ? StorageManager.get('replayMode') === 'true'
    : false;

export const init = {
    echo: {
        state: 'disconnected',
        socket: null
    },
    id: null,
    token: null,
    session: null,
    streak: null,
    username: null,
    coppa: null,
    tutorial_completed: false,
    profanity: false,
    passcode: null,
    ban: null,
    unclaimed_vip: 0,
    lifetime_vip: 0,
    win_streak: 0,
    subscription_active: false,
    subscription_cancelled: false,
    subscription_expires_at: null,
    maintenance: null,
    ability_points: [],
    characters: [],
    character_points: [],
    currencies: {
        attribute_points: 0,
        coins: 0,
        tickets: 0,
    },
    applications: [],
    invites: [],
    season: null,
    guild: null,
    guild_online: [],   // TODO: THIS COULD BE A SET INSTEAD OF AN ARRAY
    references: {
        id: null,
        data: null,
        loading: false,
        loaded: false,
        error: false,
    },
    notification_preferences: {
        guild: true,
        season: true,
        store_and_offers: true,
        streak_protection: true,
    },
    notifications: [],
    achievements: [],
    login_rewards: [],
    release_notes: null,
    sales: [],
    limited_chests: [],
    limited_discounts: [],
    ads_enabled: false,
    ads_rewarded_unit_id: null,
    tier_costs,
    ability_costs,
    vip_levels: vip_levels.sort((a, b) => b.required - a.required),
    volume,
    haptic,
    isMasquerade,
    replayMode,
};
